
export const getTokenPrice = (array, token) => {
  return array.find((element) => {
    if (element.token === token) {
      return true;
    }
    return false;
  })
};